/**
 * A pseudo-replacement which instruct a Replacer to leave
 * the matched text as-is.
 *
 * This value should be used read-only.
 */
export = Symbol('noOp');
